import { VehicleActionMenu } from "./VehicleActionMenu";

export const vehicleListColumns = (isReadOnly) => [
  ...(!isReadOnly
    ? [
        {
          field: "actions",
          headerName: "",
          type: "actions",
          width: 50,
          getActions: (params) => [
            <VehicleActionMenu id={params.id} row={params.row} />,
          ],
        },
      ]
    : []),
  {
    field: "registration_number",
    headerName: "License Plate",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "vin",
    headerName: "Mac Id / VIN",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "make",
    headerName: "Make",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "model",
    headerName: "Model",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "vehicle_type",
    headerName: "Type",
    flex: 1,
    minWidth: 100,
  },
];
